import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import "../css/CampoBusca.css";

// Campo de busca único usado nas faixas vermelhas da lista de restaurantes e do cardápio.
const CampoBusca = ({ valor, onChange, placeholder, rotulo, dica }) => (
  <div className="campo-busca">
    <FaSearch className="campo-busca-icone" aria-hidden="true" />
    <input
      type="search"
      className="campo-busca-input"
      placeholder={placeholder}
      aria-label={rotulo || placeholder}
      value={valor}
      onChange={(e) => onChange(e.target.value)}
    />
    {valor && (
      <button type="button" className="campo-busca-limpar" aria-label="Limpar busca" onClick={() => onChange("")}>
        <FaTimes aria-hidden="true" />
      </button>
    )}
    {dica && <p className="campo-busca-dica" role="status">{dica}</p>}
  </div>
);

export default CampoBusca;
